export default function HTMLPaste() {
  return (
    <li>
      <h3 id="paste-html">Paste it in your HTML code</h3>
      <p>Paste the code you've copied in the HTML code in your project.</p>
    </li>
  );
}
